import { CustomerAPI, json } from '@driftt/dapper'
export const getHasNewMeetingAppCutover = () => {
  return CustomerAPI.get(`/cutover/organizations/-1?namespace=HAS_NEW_MEETINGS_APP`)
        .then(json)
}

export const getHasLicensesEnabled = orgId => {
  return CustomerAPI.get(`/cutover/organizations/${orgId}?namespace=LICENSES_ENABLED`)
        .then(json)
}

export const getHasMarketplaceModalCutover = orgId => {
  return CustomerAPI.get(`/cutover/organizations/${orgId}?namespace=HAS_MARKETPLACE_MODAL`)
        .then(json)
}

export const getVideoWelcomeMessageCutover = () => {
  return CustomerAPI.get('/cutover/organizations/fromContext?namespace=VIDEO_WELCOME_MESSAGE')
    .then(json)
}

export const getDriftCutover = ({ orgId, cutoverName }) => CustomerAPI.get(`/cutover/organizations/${orgId}?namespace=${cutoverName}`).then(json)

export const getOutboundNotificationsCutover = orgId => {
  return CustomerAPI.get(`/cutover/organizations/${orgId}?namespace=OUTBOUND_ACTIVITY_PAGE_VIEW_NOTIFICATION`)
    .then(json)
}

export const getPlaybooksTableCutover = () => {
  return CustomerAPI.get(`/cutover/organizations/fromContext?namespace=PLAYBOOKS_TABLE_IN_PEW`)
    .then(json)
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/access/api.js